<template>
  <div class="col-4 col-sm-3 col-md-2 auction-card">
    <div
      class="card card-auction innner-icon product-default inner-quickview text-center"
    >
      <h2 class="product-title mt-1 two-lines-title">
        <a :href="auction.auctionUrl"
          ><span class="two-lines-title">{{ auction.productName }}</span></a
        >
      </h2>
      <div
        :style="
          'position: relative' +
          (auction.status !== 'InProgress' ? ';margin-bottom:5px' : '')
        "
      >
        <form
          v-if="authenticated"
          method="post"
          class="m-0 p-0 text-right mr-1 favorite-container"
          :action="'/auctions/' + auction.id + '/watch'"
        >
          <input type="hidden" name="_token" :value="getCsrfToken()" />

          <button
            v-if="auction.isWatchingAuction"
            class="btn btn-link m-0 p-0"
            type="submit"
          >
            <i
              class="fas fa-heart text-danger round-bg-white"
              data-toggle="tooltip"
              title="Remove auction from your watchlist"
            ></i>
          </button>
          <button v-else class="btn btn-link m-0 p-0" type="submit">
            <i
              class="far fa-heart text-danger round-bg-white"
              data-toggle="tooltip"
              title="Add auction to your watchlist"
            ></i>
          </button>
        </form>
        <a :href="auction.auctionUrl">
          <img
            class="card-img-top border-top"
            data-ww="178" data-hh="179"
            :src="auction.productPictureUrl"
          />
        </a>
        <vac
          v-if="auction.status === 'Scheduled'"
          :end-time="auction.nextRoundAt"
          ref="countdown"
          :key="countdownKey"
        >
          <span slot="process" slot-scope="{ timeObj }">
            <div
              class="img-overlay d-flex justify-content-center"
              :class="countdownStyle(timeObj.ceil.s)"
            >
              {{
                timeObj.d > 0
                  ? `${timeObj.d} Day${timeObj.d == 1 ? "" : "s"} ${
                      timeObj.h
                    }:${timeObj.m}:${timeObj.s}`
                  : `${timeObj.h}:${timeObj.m}:${timeObj.s}`
              }}
            </div>
          </span>
          <span slot="finish"
            ><div
              class="img-overlay d-flex justify-content-center"
              :class="countdownStyle(0)"
            >
              <i
                class="fas fa-spinner fa-spin"
                style="line-height: 1.4"
              ></i></div
          ></span>
        </vac>
        <div
          class="img-overlay d-flex justify-content-center bg-green"
          v-if="auction.status === 'InProgress'"
        >
          <span>Auction Started</span>
        </div>
        <div
          class="img-overlay d-flex justify-content-center bg-dark"
          v-if="auction.status === 'Completed'"
        >
          <span>SOLD!</span>
        </div>
        <div
          class="img-overlay d-flex justify-content-center bg-grey"
          v-if="auction.status === 'Canceled'"
        >
          <span>Finished</span>
        </div>
      </div>
      <vac
        v-if="auction.status === 'InProgress'"
        :end-time="auction.nextRoundAt"
        ref="countdown"
        :key="countdownKey"
      >
        <span slot="process" slot-scope="{ timeObj }">
          <div class="progressBar">
            <div
              v-bind:style="{
                width: (timeObj.ceil.s / auction.roundTime) * 100 + '%',
              }"
            ></div>
          </div>
        </span>
        <span slot="finish"><div class="progressBar"></div></span>
      </vac>
      <div class="product-details">
        <div class="price-box w-100 d-flex flex-column mb-0">
          <div
            v-if="
              auction.status === 'Scheduled' || auction.status === 'InProgress'
            "
            class="product-price py-1"
            style="font-size: 1.3rem"
          >
            <p class="mb-0">
              <span v-if="auction.status === 'Scheduled'">Starting at:</span>
              <span v-else>Started at:</span>
              <span class="old-price" style="font-size: 1.25rem">{{
                auction.originalPrice | formatDollars
              }}</span>
              <span
                v-bind:class="{ 'old-price': auction.status === 'InProgress' }"
                style="font-size: 1.35rem"
              >
                {{ auction.startingPrice | formatDollars }}
              </span>
            </p>

            <p
              class="my-1 py-2"
              style="font-size: 1.35rem"
              v-if="auction.status === 'Scheduled'"
            >
              Estimated sale:
              <span
                class="font-weight-bold p-1"
                style="color: rgb(255, 140, 0)"
                >{{ auction.estimatedSale | formatDollars }}</span
              >
            </p>
            <p
              class="my-1 py-2"
              style="font-size: 1.35rem"
              v-else-if="auction.status === 'InProgress'"
              ref="currentPrice"
            >
              Current price:
              <span class="font-weight-bold p-1" style="color: green">{{
                auction.currentPrice | formatDollars
              }}</span>
            </p>
          </div>
          <div
            v-else-if="auction.status === 'Completed'"
            class="product-price py-1"
            style="font-size: 1.35rem"
          >
            Sold at:
            <span class="old-price" style="font-size: 1.25rem">{{
              auction.originalPrice | formatDollars
            }}</span>
            {{ auction.winningPrice | formatDollars }}
            <p class="my-1 py-2 text-muted">
              Congrats {{ auction.winner.name }}!
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    auction: {
      required: true,
    },
  },
  data() {
    return {
      countdownKey: 0,
      authenticated: window.authenticated,
      keepCompletedAuctionsSeconds: window.keepCompletedAuctionsSeconds,
    };
  },
  methods: {
    auctionStatusText: function (status) {
      if (status === "Completed") {
        return "Auction Ended";
      } else if (status === "InProgress") {
        return "Auction Started";
      } else if (status === "Canceled") {
        return "Auction Canceled";
      }
    },
    countdownStyle: function (secondsLeft) {
      if (secondsLeft > 86400) {
        return " bg-purple";
      }
      if (secondsLeft > 3600) {
        return " bg-orange";
      }
      if (secondsLeft > 240) {
        return " bg-red";
      }
      return " bg-red countdown-flash";
    },
    getCsrfToken: function () {
      return document.querySelector('meta[name="csrf-token"]').content;
    },
  },
  watch: {
    "auction.nextRoundAt": function (newVal, oldVal) {
      if (!!this.$refs.countdown) {
        this.countdownKey += 1;
      }
    },
    "auction.currentPrice": function (newVal, oldVal) {
      const vm = this;
      if (!!vm.$refs.currentPrice) {
        vm.$refs.currentPrice.classList.add("flash");
        setTimeout(function () {
          if (!!vm.$refs.currentPrice) {
            vm.$refs.currentPrice.classList.remove("flash");
          }
        }, 2000);
      }
    },
    "auction.status": function (newVal, oldVal) {
      if (newVal === "Canceled") {
        location.reload();
      }
    },
  },
};
</script>
